import { ChangeDetectionStrategy, Component, computed, input, output, signal } from "@angular/core";

@Component({
  selector: "app-onboarding-task",
  templateUrl: "./onboarding-task.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "tw-block",
    role: "listitem",
  },
})
export class OnboardingTaskComponent {
  readonly completed = input(false);
  readonly title = input.required<string>();
  readonly subtitle = input<string>();
  readonly route = input<string | unknown[]>();
  readonly ctaText = input<string>();
  readonly ctaIcon = input<string>();
  readonly isDisabled = input(false);
  readonly dimWhenCompleted = input(false);
  readonly showSubtitleWhenComplete = input(false);

  readonly ctaClick = output<void>();

  private readonly _isActive = signal(false);
  protected readonly isActive = this._isActive.asReadonly();

  protected readonly shouldShowSubtitle = computed(() => {
    if (!this.completed()) {
      return Boolean(this.subtitle());
    }
    return this.showSubtitleWhenComplete() && Boolean(this.subtitle());
  });

  setActive(active: boolean): void {
    this._isActive.set(active);
  }
}
